<div class="verification-parent">
  <ng-container *ngIf="hasEmailVerification">
    <si-email-verification-dialog [(displayDialog)]="displayVerificationDialog"
                                  (displayDialogChange)="onChangeDisplayVerificationDialog($event)"
                                  [emailValue]="model.userProfile?.contactData?.email"
                                  [(emailVerificationCode)]="model.verificationCode"
                                  (emailVerificationCodeChange)="onChangeVerificationCode()"
                                  [emailVerificationErrorText]="verificationErrorText"
    ></si-email-verification-dialog>
  </ng-container>
  <ng-container *ngIf="hasSmsVerification">
    <si-sms-verification-dialog [(displayDialog)]="displayVerificationDialog"
                                (displayDialogChange)="onChangeDisplayVerificationDialog($event)"
                                [phoneValue]="model.userProfile?.contactData?.phone?.value"
                                [(smsVerificationCode)]="model.verificationCode"
                                (smsVerificationCodeChange)="onChangeVerificationCode()"
                                [smsVerificationErrorText]="verificationErrorText"
    ></si-sms-verification-dialog>
  </ng-container>
  <ng-container *ngIf="displayLinkPatientErrorDialog">
    <si-generic-dialog [(displayDialog)]="displayLinkPatientErrorDialog"
                        dialogTitle="SI_LINK_VALIDATION_FAIL"
                        dialogImg="assets/images/user_not_found.svg"
                        [dialogText]="linkPatientErrorText"
                        button1Text="SI_CLOSE"
                        button1Class="si-button_secondary"
    ></si-generic-dialog>
  </ng-container>
  <ng-container *ngIf="displayLinkPatientSuccessDialog">
    <si-generic-dialog [(displayDialog)]="displayLinkPatientSuccessDialog"
                        dialogTitle="SI_LINKED_USER"
                        dialogImg="assets/images/user_history.svg"
                        dialogText="SI_LINKED_USER_TEXT"
                        button1Text="CORE_ACCEPT"
                        button1Class="si-button_main"
                        (displayDialogChange)="onChangeLinkPatientSuccessDialog($event)"
    ></si-generic-dialog>
  </ng-container>
</div>
